module.exports = __webpack_public_path__ + "media/images/24hours-fc68dc4c6a9d2fceb7755262ad1fa4ea.svg";